var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('img',{staticStyle:{"width":"100%","margin-bottom":"-6px"},attrs:{"src":_vm.imgUrl}})]),_c('div',{staticClass:"demo-bg"},[_c('div',{staticClass:"demo",domProps:{"innerHTML":_vm._s(_vm.dataL['content'])}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }